module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-form-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "login-form-panel"
    }
  }, [_c('form', {
    attrs: {
      "id": "login-form"
    }
  }, [_c('h1', [_vm._v("Log in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "emailField",
    attrs: {
      "type": "text",
      "placeholder": "Email..."
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password..."
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "change": function($event) {
        _vm.errors = []
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remember-me checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "id": "remember-me-check"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "fake-checkbox",
    attrs: {
      "for": "remember-me-check"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-description",
    attrs: {
      "for": "remember-me-check"
    }
  }, [_vm._v("Remember Me")])]), _vm._v(" "), (_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v("Log In")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702e62f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HomePage/LoginForm.vue
// module id = 402
// module chunks = 1